const storage = {
  get(key, fallback = null) {
    const value = window.localStorage.getItem(key);
    return value === null ? fallback : value;
  },
  set(key, value) {
    window.localStorage.setItem(key, value);
  },
  remove(key) {
    window.localStorage.removeItem(key);
  },
  clear() {
    window.localStorage.clear();
  }
};

export default storage;
